/** @jsxImportSource @emotion/react */
import Modal from 'react-bootstrap-modal';
import { useSelector } from 'react-redux';
import { selectAutoshipId, selectIsPws } from 'cart-ui-react/src/autoshipState/selectors';
import axios from 'axios';
import t from '@rcm/i18n-client';

const EmptyCartModal = ({ open, setOpen }) => {
  const autoshipId = useSelector(selectAutoshipId);
  const isPws = useSelector(selectIsPws);

  const handleCancel = () => {
    const body = {
      isPws: isPws,
      id: autoshipId,
    };
    axios.post(`/api/v2/cancel-autoship`, body);
    setOpen(false);
    window.location.href = '/cart#/autoship-list';
  };

  return (
    <Modal
      noBackdrop
      show={open}
      head={
        <div>
          <h3>
            {t('Saving the autoship without items will cancel it, are you sure you would like to continue') + '?'}
          </h3>
        </div>
      }
      foot={
        <div>
          <button className='btn btn-default' onClick={() => setOpen(false)}>
            {t('No')}
          </button>
          <button className='btn btn-primary' onClick={handleCancel}>
            {t('Yes, cancel this Autoship')}
          </button>
        </div>
      }
    />
  );
};

export default EmptyCartModal;
